export const qrValue = (...values: any[]) => {
  const result = values.join("|");
  return result;
};
